export default {
    viewBox: "0 0 32 32",
    children: [
        {
            name: "rect",
            attribs: {
                x: "1",
                y: "1",
                fill: "none",
                stroke: "#000000",
                "stroke-width": "1",
                width: "30",
                height: "30",
            },
            children: [],
        },
        {
            name: "circle",
            attribs: {
                fill: "red",
                r: "2.5",
                cy: "5.5",
                cx: "5.5",
            },
            children: [],
        },
        {
            name: "circle",
            attribs: {
                fill: "none",
                stroke: "yellow",
                "stroke-width": "1",
                r: "2.5",
                cy: "12.5",
                cx: "5.5",
            },
            children: [],
        },
        {
            name: "circle",
            attribs: {
                fill: "none",
                stroke: "yellow",
                "stroke-width": "1",
                r: "2.5",
                cy: "19.5",
                cx: "5.5",
            },
            children: [],
        },
        {
            name: "circle",
            attribs: {
                fill: "none",
                stroke: "yellow",
                "stroke-width": "1",
                r: "2.5",
                cy: "26.5",
                cx: "5.5",
            },
            children: [],
        },

        {
            name: "circle",
            attribs: {
                fill: "none",
                stroke: "yellow",
                "stroke-width": "1",
                r: "2.5",
                cy: "5.5",
                cx: "12.5",
            },
            children: [],
        },
        {
            name: "circle",
            attribs: {
                fill: "red",
                r: "2.5",
                cy: "12.5",
                cx: "12.5",
            },
            children: [],
        },
        {
            name: "circle",
            attribs: {
                fill: "none",
                stroke: "yellow",
                "stroke-width": "1",
                r: "2.5",
                cy: "19.5",
                cx: "12.5",
            },
            children: [],
        },
        {
            name: "circle",
            attribs: {
                fill: "none",
                stroke: "yellow",
                "stroke-width": "1",
                r: "2.5",
                cy: "26.5",
                cx: "12.5",
            },
            children: [],
        },

        {
            name: "circle",
            attribs: {
                fill: "none",
                stroke: "yellow",
                "stroke-width": "1",
                r: "2.5",
                cy: "5.5",
                cx: "19.5",
            },
            children: [],
        },
        {
            name: "circle",
            attribs: {
                fill: "none",
                stroke: "yellow",
                "stroke-width": "1",
                r: "2.5",
                cy: "12.5",
                cx: "19.5",
            },
            children: [],
        },
        {
            name: "circle",
            attribs: {
                fill: "red",
                r: "2.5",
                cy: "19.5",
                cx: "19.5",
            },
            children: [],
        },
        {
            name: "circle",
            attribs: {
                fill: "none",
                stroke: "yellow",
                "stroke-width": "1",
                r: "2.5",
                cy: "26.5",
                cx: "19.5",
            },
            children: [],
        },

        {
            name: "circle",
            attribs: {
                fill: "none",
                stroke: "yellow",
                "stroke-width": "1",
                r: "2.5",
                cy: "5.5",
                cx: "26.5",
            },
            children: [],
        },
        {
            name: "circle",
            attribs: {
                fill: "none",
                stroke: "yellow",
                "stroke-width": "1",
                r: "2.5",
                cy: "12.5",
                cx: "26.5",
            },
            children: [],
        },
        {
            name: "circle",
            attribs: {
                fill: "none",
                stroke: "yellow",
                "stroke-width": "1",
                r: "2.5",
                cy: "19.5",
                cx: "26.5",
            },
            children: [],
        },
        {
            name: "circle",
            attribs: {
                fill: "red",
                r: "2.5",
                cy: "26.5",
                cx: "26.5",
            },
            children: [],
        },
    ],
}